export function isFailedToFetchError(error: unknown): boolean {
  return error instanceof Error && error.message === "Failed to fetch";
}
